(function () {
    'use strict';

    angular.module("imApp").factory("stockTransferLogService", ['$ihttp', function ($ihttp) {
        let service = {
            getStockTransferLog: function (parms) {
                return $ihttp.post({
                    method: 2319,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
